<script lang="ts">
    import { createEventDispatcher, setContext } from "svelte";
    import { get, readable, writable } from "svelte/store";
    import type { Fn, FormTools, InputControl } from "../global";

    const _valid = writable(true);
    const _submit = writable(false);
    const dispatch = createEventDispatcher();

    export const valid = readable(false, set => _valid.subscribe(set));
    export const submit = readable(false, set => _submit.subscribe(set));

    const controls = new Map<InputControl, Fn>();

    export let novalidate = true;

    const formTools: FormTools = {
        registerControl,
        removeControl,
        submit,
    };

    setContext('formTools', formTools);

    function registerControl(control: InputControl) {
        if (controls.has(control)) {
            return;
        }
        //Añadimos el control al mapa de controles de manera que
        //cuando se suscribamos la función updateValidity
        //esta encuentre el control en el mapa.
        controls.set(control, null);
        const unsubscribeFn = control.valid.subscribe(updateValidity);
        //Añadimos la función de desuscripción al mapa
        controls.set(control, unsubscribeFn);
    }

    function removeControl(control: InputControl) {
        if (!controls.has(control)) {
            return;
        }
        controls.get(control)();
        controls.delete(control);
    }

    function updateValidity() {
        $_valid = ![...controls.keys()].some(({ valid }) => !get(valid));
    }

    function onSubmit() {
        _submit.set(true);
        dispatch('submit');
    }

</script>

<form {novalidate} on:submit|preventDefault={onSubmit}>
    <slot></slot>
</form>
